var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranx888(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m135 331h81.53125c3.042969-10.464844 7.097656-20.5 12.046875-30h-93.578125c-8.285156 0-15-6.714844-15-15s6.714844-15 15-15h113.660156c9.597656-11.417969 20.707032-21.523438 33.023438-30h-146.683594c-8.285156 0-15-6.714844-15-15s6.714844-15 15-15h150c10.078125 0 17.292969 9.757812 14.34375 19.398438 18.46875-9.570313 38.960938-15.746094 60.65625-17.710938v-177.6875c0-19.300781-15.699219-35-35-35h-290c-19.300781 0-35 15.699219-35 35v381c0 19.300781 15.699219 35 35 35h192.554688c-13.976563-27.730469-19.796876-58.773438-16.777344-90h-75.777344c-8.285156 0-15-6.714844-15-15s6.714844-15 15-15zm0-240h150c8.285156 0 15 6.714844 15 15s-6.714844 15-15 15h-150c-8.285156 0-15-6.714844-15-15s6.714844-15 15-15zm0 60h150c8.285156 0 15 6.714844 15 15s-6.714844 15-15 15h-150c-8.285156 0-15-6.714844-15-15s6.714844-15 15-15zm-60 210c-8.285156 0-15-6.714844-15-15s6.714844-15 15-15 15 6.714844 15 15-6.714844 15-15 15zm0-60c-8.285156 0-15-6.714844-15-15s6.714844-15 15-15 15 6.714844 15 15-6.714844 15-15 15zm0-60c-8.285156 0-15-6.714844-15-15s6.714844-15 15-15 15 6.714844 15 15-6.714844 15-15 15zm0-60c-8.285156 0-15-6.714844-15-15s6.714844-15 15-15 15 6.714844 15 15-6.714844 15-15 15zm0-60c-8.285156 0-15-6.714844-15-15s6.714844-15 15-15 15 6.714844 15 15-6.714844 15-15 15zm0 0",
    fill: "#52aedd",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375 242c-74.4375 0-135 60.5625-135 135s60.5625 135 135 135 135-60.5625 135-135-60.5625-135-135-135zm15 134c0 8.285156-6.714844 15-15 15h-45c-8.285156 0-15-6.714844-15-15s6.714844-15 15-15h30v-45c0-8.285156 6.714844-15 15-15s15 6.714844 15 15zm0 0",
    fill: "#52aedd",
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranx888);
export default __webpack_public_path__ + "static/media/tranx-888.c71e7d5031c30a3b61d30c267e4eb242.svg";
export { ForwardRef as ReactComponent };